import authAxiosObs from "common/axios/authAxiosObservable";

export default class BaseRxApiService {
  constructor(documentName) {
    this.documentName = documentName;
  }
  create(data) {
    const body = {
      data,
    };
    return authAxiosObs.post(`/${this.documentName}`, body);
  }

  get(filter, limit = null, orderBy = null, order = null, offset = null) {
    const params = { filter, limit, orderBy, order, offset };
    return authAxiosObs.get(`/${this.documentName}`, { params });
  }

  getById(id) {
    return authAxiosObs.get(`/${this.documentName}/${id}`);
  }

  deleteList(ids) {
    return authAxiosObs.delete(`/${this.documentName}`, { data: ids });
  }

  delete(id) {
    return authAxiosObs.delete(`/${this.documentName}/${id}`);
  }

  update(data) {
    return authAxiosObs.put(`/${this.documentName}`, { data: data });
  }
}
